import React, { useEffect, useRef, useState } from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'
import { CONFIG } from './config'
import { useWindowSize } from './useWindowSize'
/**
 * Component for Scrollytelling
 *
 * Elements for front layer
 * @prop {React.ReactChild[]} front
 *
 * Function returning background layer element
 * index = current visible front layer element
 * @prop {( index:Number )=> React.ReactChild } background
 *
 * gap between the front layer elements as viewport height
 * @prop { Number } distance
 *
 * space after last front element as viewport height
 * @prop { Number } endSpace
 *
 * @returns { React.Element } React Component
 */

export const Scroller = ({
  front,
  back,
  distance = CONFIG.default.spacerHeight,
  endSpace = CONFIG.default.endSpace,
  className
}: {
  front: React.ReactChild[]
  back: (e: number) => React.ReactChild
  distance?: number
  endSpace?: number
  className?: string
}) => {
  const windowSize = useWindowSize()
  const [mainHeight, setMainHeight] = useState(0)
  const frontRef = useRef<HTMLDivElement>(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [startPos, setStartPos] = useState(0)

  const handleWaypointEnter = (i: number, e: Waypoint.CallbackArgs) => {
    if (e.currentPosition === 'inside' && e.previousPosition === 'below') {
      setCurrentIndex(i)
    }
  }
  const handleWaypointLeave = (i: number, e: Waypoint.CallbackArgs) => {
    if (e.currentPosition === 'below' && e.previousPosition === 'inside') {
      setCurrentIndex(i - 1)
    }
  }
  useEffect(() => {
    if (!frontRef.current) return
    setMainHeight(frontRef.current.clientHeight)
  }, [frontRef.current, windowSize.width])

  return (
    <div
      className={'Scroller ' + className}
      style={{
        minHeight: `calc(${mainHeight + 'px'} + ${endSpace}vh)`
      }}
    >
      <div className='back'>{back(currentIndex)}</div>
      <div className='front' ref={frontRef}>
        {front.map((element, i) => {
          return (
            <>
              <div className='spacer' style={{ minHeight: distance + 'vh' }} />
              <div className='frontel'>
                <Waypoint
                  bottomOffset={20}
                  onEnter={e => handleWaypointEnter(i, e)}
                  onLeave={e => handleWaypointLeave(i, e)}
                >
                  {element}
                </Waypoint>
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}
